import HeaderFactory from "./HeaderFactory";

interface HeaderWrapperProps {
  showTopBar?: number;
  showPromotional?: number;
}

export default function HeaderWrapper({
  showTopBar = 1,
  showPromotional = 0,
}: HeaderWrapperProps) {
  return (
    <HeaderFactory
      showTopBar={showTopBar}
      showPromotional={showPromotional}
    />
  );
}

